import type {
  FreeShippingCardContentProps,
  GiftContentResponse
} from "./types";

export const freeShippingCardContent = ({
  currencySymbol,
  shippingThreshold
}: FreeShippingCardContentProps): GiftContentResponse => {
  return {
    imageUrl:
      "https://beautypie.bynder.com/m/79fc08def7d87db8/webimage-DELIVERY_WEB.jpg",
    title: "Free Delivery",
    description:
      shippingThreshold !== null
        ? `Unlock FREE standard shipping when you spend over ${currencySymbol}${shippingThreshold}`
        : ""
  };
};
